module.exports = __webpack_public_path__ + "img/share.477d7878.svg";